
<mat-card class="matcardcontent">
    <mat-card-header>
        <mat-card-title>Lista commesse</mat-card-title>
    </mat-card-header>
    <mat-card-content>


        <table [style.display]="isDetailsHidden()">
        <tr>
          <td align="left">
              <span style="font-family:Roboto; font-weight: bold; font-size: 18px;">Dettaglio commessa: {{commessa.Codice}}</span>
          </td>
        </tr>
        </table>

            <table mat-table [style.display]="isDetailsHidden()" [dataSource]="dataSource2" class="mat-elevation-z8">
              <ng-container matColumnDef="Marcaveicolo">
                  <th [style.display]="getConfigurazione().Marcaveicolo" mat-header-cell *matHeaderCellDef>Marca Veicolo
                    <img src="./assets/images/sort.png" (click)="manageClick('Marcaveicolo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Marcaveicolo" mat-cell *matCellDef="let commessa"> {{commessa.Marcaveicolo}} </td>
              </ng-container>

              <ng-container matColumnDef="Modelloveicolo">
                  <th [style.display]="getConfigurazione().Modelloveicolo" mat-header-cell *matHeaderCellDef>Modello Veicolo
                    <img src="./assets/images/sort.png" (click)="manageClick('Modelloveicolo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Modelloveicolo" mat-cell *matCellDef="let commessa"> {{commessa.Modelloveicolo}} </td>
              </ng-container>


              <ng-container matColumnDef="Telaioveicolo">
                  <th [style.display]="getConfigurazione().Telaioveicolo" mat-header-cell *matHeaderCellDef>Telaio Veicolo
                    <img src="./assets/images/sort.png" (click)="manageClick('Telaioveicolo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Telaioveicolo" mat-cell *matCellDef="let commessa"> {{commessa.Telaioveicolo}} </td>
              </ng-container>

              <ng-container matColumnDef="Marcafrigo">
                  <th [style.display]="getConfigurazione().Marcafrigo" mat-header-cell *matHeaderCellDef>Marca Frigo
                    <img src="./assets/images/sort.png" (click)="manageClick('Marcafrigo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Marcafrigo" mat-cell *matCellDef="let commessa"> {{commessa.Marcafrigo}} </td>
              </ng-container>

              <ng-container matColumnDef="Matricolafrigo">
                  <th [style.display]="getConfigurazione().Matricolafrigo" mat-header-cell *matHeaderCellDef>Matricola Frigo
                    <img src="./assets/images/sort.png" (click)="manageClick('Matricolafrigo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Matricolafrigo" mat-cell *matCellDef="let commessa"> {{commessa.Matricolafrigo}} </td>
              </ng-container>

              <ng-container matColumnDef="Modellofrigo">
                  <th [style.display]="getConfigurazione().Modellofrigo" mat-header-cell *matHeaderCellDef>Modello Frigo
                    <img src="./assets/images/sort.png" (click)="manageClick('Modellofrigo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Modellofrigo" mat-cell *matCellDef="let commessa"> {{commessa.Modellofrigo}} </td>
              </ng-container>

              <ng-container matColumnDef="Annofabbricazionefrigo">
                  <th [style.display]="getConfigurazione().Annofabbricazionefrigo" mat-header-cell *matHeaderCellDef>Anno Fabbricazione Frigo
                    <img src="./assets/images/sort.png" (click)="manageClick('Annofabbricazionefrigo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Annofabbricazionefrigo" mat-cell *matCellDef="let commessa"> {{commessa.Annofabbricazionefrigo}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
            </table>

<!--      <form>-->
<br>

           <mat-form-field appearance="fill" style="padding-right: 10px">
             <mat-label class="text-sm">Stato</mat-label>
             <mat-select [(ngModel)]="selectedValueStato" name="stato" (selectionChange)="manageChangeStato()" class="text-sm">
               <mat-option *ngFor="let stato of stati" [value]="stato.Nome">
                 {{stato.Nome}}
               </mat-option>
             </mat-select>
           </mat-form-field>

           <mat-form-field style="padding-right:10px">
              <mat-label class="text-sm">Targa veicolo</mat-label>
              <input matInput [(ngModel)]="filtroTargaveicolo" name="filtroTargaveicolo" (keyup)="onFiltroTargaveicoloKeyup($event)" class="text-sm">
           </mat-form-field>

           <mat-form-field style="padding-right:10px">
              <mat-label class="text-sm">Cliente</mat-label>
              <input matInput [(ngModel)]="filtroCliente" name="filtroCliente" (keyup)="onFiltroClienteKeyup($event)" class="text-sm">
           </mat-form-field>

           <mat-form-field class="text-sm" style="padding-right: 10px">
                     <mat-label class="text-sm">Data accettazione</mat-label>
                     <input matInput [matDatepicker]="startpicker"
                       placeholder="Data Accettazione"
                       [(ngModel)]="selectedValueDataingresso"
                       (dateChange)="onFiltroDataingressoDatechange($event)">
                     <mat-datepicker-toggle matIconSuffix [for]="startpicker"></mat-datepicker-toggle>
                     <mat-datepicker #startpicker startView="month" ></mat-datepicker>
           </mat-form-field>

           <mat-form-field class="text-sm" style="padding-right: 10px">
                     <mat-label class="text-sm">Data fine lavori</mat-label>
                     <input matInput [matDatepicker]="endpicker"
                       placeholder="Data Accettazione"
                       [(ngModel)]="selectedValueDatafine">
                     <mat-datepicker-toggle matIconSuffix [for]="endpicker"></mat-datepicker-toggle>
                     <mat-datepicker #endpicker startView="month" ></mat-datepicker>
           </mat-form-field>



  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="sel">
      <!--  <mat-header-cell *matHeaderCellDef>Altro
  <!--            <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox> -->
                    <th mat-header-cell *matHeaderCellDef>Altro

                    </th>
      <!--  </mat-header-cell>
        <mat-cell *matCellDef="let commessa">-->
          <td mat-cell *matCellDef="let commessa">
            <mat-checkbox
              (click)="manageCheckboxclick($event, commessa)"
              (change)="$event ? selection.toggle(commessa) : null"
              [checked]="selection.isSelected(commessa)">
            </mat-checkbox>
          </td>
      <!--    </mat-cell> -->
    </ng-container>

    <ng-container matColumnDef="Codice">
        <th [style.display]="getConfigurazione().Codice" mat-header-cell *matHeaderCellDef>Codice
          <img src="./assets/images/sort.png" (click)="manageClick('Codice')"/>
        </th>
        <td [style.display]="getConfigurazione().Codice" mat-cell *matCellDef="let commessa"> {{commessa.Codice}} </td>
    </ng-container>

    <ng-container matColumnDef="Numerocommessa">
        <th [style.display]="getConfigurazione().Numerocommessa" mat-header-cell *matHeaderCellDef>Numero Commessa
          <img src="./assets/images/sort.png" (click)="manageClick('Numerocommessa')"/>
        </th>
        <td [style.display]="getConfigurazione().Numerocommessa" mat-cell *matCellDef="let commessa"> {{commessa.Numerocommessa}} </td>
    </ng-container>

    <ng-container matColumnDef="Codiceazienda">
        <th [style.display]="getConfigurazione().Codiceazienda" mat-header-cell *matHeaderCellDef>Codiceazienda
          <img src="./assets/images/sort.png" (click)="manageClick('Codiceazienda')"/>
        </th>
        <td [style.display]="getConfigurazione().Codiceazienda" mat-cell *matCellDef="let commessa"> {{commessa.Codiceazienda}} </td>
    </ng-container>

    <ng-container matColumnDef="Nomecliente">
        <th [style.display]="getConfigurazione().Nomecliente" mat-header-cell *matHeaderCellDef>Cliente
          <img src="./assets/images/sort.png" (click)="manageClick('Nomecliente')"/>
        </th>
        <td [style.display]="getConfigurazione().Nomecliente" mat-cell *matCellDef="let commessa"> {{commessa.Nomecliente}} </td>
    </ng-container>

    <ng-container matColumnDef="Targaveicolo">
        <th [style.display]="getConfigurazione().Targaveicolo" mat-header-cell *matHeaderCellDef>Targa Veicolo
          <img src="./assets/images/sort.png" (click)="manageClick('Targaveicolo')"/>
        </th>
        <td [style.display]="getConfigurazione().Targaveicolo" mat-cell *matCellDef="let commessa"> {{commessa.Targaveicolo}} </td>
    </ng-container>

    <ng-container matColumnDef="Dataingresso">
        <th [style.display]="getConfigurazione().Dataingresso" mat-header-cell *matHeaderCellDef>Data accettazione
          <img src="./assets/images/sort.png" (click)="manageClick('Dataingresso')"/>
        </th>
        <td [style.display]="getConfigurazione().Dataingresso" mat-cell *matCellDef="let commessa"> {{commessa.Dataingresso | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="Datafine">
        <th [style.display]="getConfigurazione().Datafine" mat-header-cell *matHeaderCellDef>Data fine lavori
          <img src="./assets/images/sort.png" (click)="manageClick('Datafine')"/>
        </th>
        <td [style.display]="getConfigurazione().Datafine" mat-cell *matCellDef="let commessa"> {{commessa.Datafine | date:'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="Tot">
      <th [style.display]="getConfigurazione().Tot" mat-header-cell *matHeaderCellDef>Tot
        <img src="./assets/images/sort.png" (click)="manageClick('Tot')"/>
      </th>
      <td [style.display]="getConfigurazione().Tot" mat-cell *matCellDef="let commessa"> {{commessa.Tot}} </td>
  </ng-container>

  <ng-container matColumnDef="Eng">
      <th [style.display]="getConfigurazione().Eng" mat-header-cell *matHeaderCellDef>Eng
        <img src="./assets/images/sort.png" (click)="manageClick('Eng')"/>
      </th>
      <td [style.display]="getConfigurazione().Eng" mat-cell *matCellDef="let commessa"> {{commessa.Eng}} </td>
  </ng-container>

  <ng-container matColumnDef="Ele">
      <th [style.display]="getConfigurazione().Ele" mat-header-cell *matHeaderCellDef>Ele
        <img src="./assets/images/sort.png" (click)="manageClick('Ele')"/>
      </th>
      <td [style.display]="getConfigurazione().Ele" mat-cell *matCellDef="let commessa"> {{commessa.Ele}} </td>
  </ng-container>

    <ng-container matColumnDef="Codicetipocommessa">
        <th [style.display]="getConfigurazione().Codicetipocommessa" mat-header-cell *matHeaderCellDef>Codice Tipo Lavorazione
          <img src="./assets/images/sort.png" (click)="manageClick('Codicetipocommessa')"/>
        </th>
        <td [style.display]="getConfigurazione().Codicetipocommessa" mat-cell *matCellDef="let commessa"> {{commessa.Codicetipocommessa}} </td>
    </ng-container>

    <ng-container matColumnDef="Nometipocommessa">
        <th [style.display]="getConfigurazione().Nometipocommessa" mat-header-cell *matHeaderCellDef>Tipo Commessa
          <img src="./assets/images/sort.png" (click)="manageClick('Nometipocommessa')"/>
        </th>
        <td [style.display]="getConfigurazione().Nometipocommessa" mat-cell *matCellDef="let commessa"> {{commessa.Nometipocommessa}} </td>
    </ng-container>

    <ng-container matColumnDef="Note">
        <th [style.display]="getConfigurazione().Note" mat-header-cell *matHeaderCellDef>Note
          <img src="./assets/images/sort.png" (click)="manageClick('Note')"/>
        </th>
        <td [style.display]="getConfigurazione().Note" mat-cell *matCellDef="let commessa"> {{commessa.Note}} </td>
    </ng-container>

    <ng-container matColumnDef="Noteofficina">
        <th [style.display]="getConfigurazione().Noteofficina" mat-header-cell *matHeaderCellDef>Note Officina
          <img src="./assets/images/sort.png" (click)="manageClick('Noteofficina')"/>
        </th>
        <td [style.display]="getConfigurazione().Noteofficina" mat-cell *matCellDef="let commessa"> {{commessa.Noteofficina}} </td>
    </ng-container>

    <ng-container matColumnDef="Stato">
        <th [style.display]="getConfigurazione().Stato" mat-header-cell *matHeaderCellDef>Stato
      <!--    <img src="./assets/images/sort.png" (click)="manageClick('Stato')"/> -->
        </th>
        <td [style.display]="getConfigurazione().Stato" mat-cell *matCellDef="let commessa"> {{commessa.Statocommessa.Nome}} </td>
    </ng-container>

    <ng-container matColumnDef="Assegnatario">
        <th [style.display]="getConfigurazione().Assegnatario" mat-header-cell *matHeaderCellDef>Assegnatario
          <img src="./assets/images/sort.png" (click)="manageClick('Cognomeassegnatario')"/>
        </th>
        <td [style.display]="getConfigurazione().Assegnatario" mat-cell *matCellDef="let commessa"> {{commessa.Cognomeassegnatario}} {{commessa.Nomeassegnatario}} </td>
    </ng-container>

    <ng-container matColumnDef="build">
        <th mat-header-cell *matHeaderCellDef> Lavorazioni </th>
        <td mat-cell *matCellDef="let commessa">
          <mat-icon color="primary" (click)="build(commessa)">build</mat-icon>
        </td>
    </ng-container>

      <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Modifica </th>
          <td mat-cell *matCellDef="let commessa">
            <mat-icon color="primary" (click)="edit(commessa)">create</mat-icon>
          </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
      <td>
        <button mat-raised-button  color="primary" (click)="new()">Nuova commessa</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
